import { bankingService } from '@afterpaytouch/portal-api/consumer/bankingSessions'

export const { useUpdateBankingSessionsMutation, useGetBankingSessionLatestQuery } = bankingService
